module.exports = __webpack_public_path__ + "static/media/17_negro.4c59599e.svg";